<div
  [class.display-container]="!rightAside"
  [class.display-container-reverse]="rightAside"
  [class.hide-aside]="hideAsideOnBreakpoint"
>
  <aside>
    <div class="aside-container">
      <ng-content select="[aside-container]"></ng-content>
    </div>
  </aside>

  <div
    class="content-container"
    [class.padding-left]="!rightAside"
    [class.padding-right]="!!rightAside"
  >
    <ng-content select="[content-container]"></ng-content>
  </div>
</div>
